import { useQuery } from 'react-query';
import { get } from 'lodash';

import axiosClient from '@lib/utils/axiosClient';
import { TBroadcastFilter } from 'modules/Broadcasts';

type TFilterName = 'broadcastList' | 'userManagement' | 'groupManagement' | 'groupsUserManagement';

const fetchFilters = async () => {
  const response = await axiosClient.get('/users/filters');
  return response.data;
};

type FiltersResponse = (TBroadcastFilter & { locked: boolean }) | null;

const mapSelectToScreenQuery = (data: FiltersResponse, filterName: TFilterName) => {
  if (!data) return null;

  const specificFilterResponse = get(data, filterName);

  if (!specificFilterResponse) return null;

  return specificFilterResponse;
};

export default function useFiltersResource(filterName: TFilterName) {
  return useQuery(['filters', filterName], fetchFilters, {
    refetchOnWindowFocus: false,
    select: (data: FiltersResponse) => mapSelectToScreenQuery(data, filterName),
    cacheTime: 0,
  });
}
